import { IRuncodeService, RuncodeResponse } from './runcodeServiceTypes';

export class RuncodeServiceStub implements IRuncodeService {
	public async executeCode(
		code: string,
		target: 'client' | 'server',
	): Promise<RuncodeResponse> {
		console.log('runcode:executeCode', { code, target });

		return { result: undefined, error: null };
	}

	public async exitMenu(): Promise<void> {
		console.log('runcode:exitMenu');
	}
}
